import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

export function useRequestStatus() {
  const [requestStatus, setRequestStatus] = useState<'pending' | 'approved' | 'rejected' | null>(null);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    if (user?.email) {
      checkRequestStatus();
    }
  }, [user?.email]);

  const checkRequestStatus = async () => {
    if (!user?.email) return;

    try {
      const { data, error } = await supabase
        .from('organization_requests')
        .select('status')
        .eq('email', user.email)
        .order('created_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error && error.code !== 'PGRST116') {
        console.error('Erro ao verificar status da solicitação:', error);
        return;
      }

      setRequestStatus(data?.status as 'pending' | 'approved' | 'rejected' || null);
    } catch (error) {
      console.error('Erro ao verificar status da solicitação:', error);
    } finally {
      setLoading(false);
    }
  };

  return { requestStatus, loading, refetch: checkRequestStatus };
}